<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>

		<section class="main-content contact-section background-light">
			<div class="row contact-form-row">
				<div class="columns column5 contact-form-col">
					<contact-form name="academy" :form="form" submit-label="formSubmitAcademy" />
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: form } = await useWebsiteFetch('academy', {
	query: { language: locale.value },
	key: `${locale.value}/academy`,
});
</script>

<style scoped lang="scss">
.contact-form-col {
	margin: auto;
}

@media (max-width: 900px) {
	.contact-section {
		padding-top: 0;
	}
}
</style>
